import styled, { keyframes } from 'styled-components';
import { SizeAddiFontSmall, SizeAddiFontXxSmall } from '@addi/foundation/dist/web/sizes';
import { Paragraph, Title as TitleStyle } from '../typographies';
import { ColorAddiFontSecondary } from '@addi/foundation/dist/web/colors';
export const Container = styled.div `
  width: 100%;
  height: ${({ loaderHeight }) => (loaderHeight ? `${loaderHeight}%` : '100vh')};
  max-width: 1023px;
  background-color: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
export const Title = styled(TitleStyle) `
  text-align: center;
  margin-bottom: 8px;
  font-size: ${SizeAddiFontSmall};
  color: ${ColorAddiFontSecondary};
`;
export const Info = styled(Paragraph) `
  margin: 0;
  font-size: ${SizeAddiFontXxSmall};
  color: ${ColorAddiFontSecondary};
`;
const rotate = keyframes `
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;
export const AnimatedLoader = styled.img `
  width: 80px;
  height: 80px;
  animation: ${rotate} 1s linear infinite;
`;
export const AnimatedLoaderContainer = styled.div `
  background: ${({ image }) => `url('${image}')`};
  background-position: center;
  background-repeat: no-repeat;
  width: 80px;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
//# sourceMappingURL=ApplicationLoader.styled.js.map